import DataTable from 'datatables.net';

export default () => {
  const archiveTables = document.querySelectorAll('.TableArchive .js-archive-table');
  if (archiveTables) {
    archiveTables.forEach(table => {
      const tableInstance = new DataTable( table , {
        lengthChange: false,
        searching: false,
        info: false,
        lengthMenu: [],
        order: [],
        columnDefs: [
          {
            type: 'datetime',
          },
        ],
        language: {
          paginate: {
            first:      false,
            previous:   "<i class=\"fa fa-angle-left\"></i>",
            next:       "<i class=\"fa fa-angle-right\"></i>",
            last:       false,
          },
        },
        drawCallback:function(){
          let api = this.api();
          let pages = api.page.info().pages;

          if (pages <= 1) {
            let pagination = table.parentElement.querySelector('.dataTables_paginate');
            pagination.style.display = 'none';
          }
        },
      });
    });
  }
}
